import fetch from '../utils/fetch';


export function addUser(params) {
  return fetch({
    method: 'POST',
    url: '/user/addUser',
    data: params
  })
}

export function getUserDetail(params) {
  return fetch({
    method: 'GET',
    url: '/user/getUserDetail',
    params
  })
}

export function updateUser(params) {
  return fetch({
    method: 'POST',
    url: '/user/updateUser',
    data: params
  })
}

export function getUserList(params) {
  return fetch({
    method: 'POST',
    url: '/user/getUserList',
    data: params
  })
}

export function updateUserDeparture(params) {
  return fetch({
    method: 'POST',
    url: '/user/updateUserDeparture',
    data: params
  })
}

export function updateUserState(params) {
  return fetch({
    method: 'POST',
    url: '/user/updateUserState',
    data: params
  })
}

export function getConfigDataAuth(params) {
  return fetch({
    method: 'GET',
    url: '/user/getConfigDataAuth/v1',
    params
  })
}

export function bindDataAuth(params) {
  return fetch({
    method: 'POST',
    url: '/user/bindDataAuth',
    data: params
  })
}

export function addZiroomEmployee(params) {
  return fetch({
    method: 'POST',
    url: '/user/addZiroomEmployee',
    data: params
  })
}

export function getPosition() {
  return fetch({
    method: 'GET',
    url: '/user/position'
  })
}
export function getAllProject(params){
  return fetch({
    method: 'POST',
    url: '/user/getAllProject',
    data: params
  })
}

export function deleteUserInfo(params){
  return fetch({
    method: 'POST',
    url: '/user/deleteUserInfo',
    data: params
  })
}
